<script setup lang="ts">
defineProps<{
  suggestion: string
}>()

defineEmits<{
  select: [query: string]
}>()
</script>

<template>
  <p class="text-small font-bold">
    Mente du å skrive
    <button type="button" class="hover:underline font-medium italic text-blurple-300 transition-colors" :aria-label="`Søk etter ${suggestion} i stedet`" @click="$emit('select', suggestion)">
      {{ suggestion }}
    </button>
    ?
  </p>
</template>
